import React, { useEffect, useState } from "react";
import "./Multimedia_Services_inner.css";
import Get_In_Touch from "../All_services_inner/Video_Wala_Bus_Stand/Video_Wala_Bus_Stand_inner_content/Get_In_Touch/Get_In_Touch";
import Multimedia_Services_info from "./Multimedia_Services_info/Multimedia_Services_info";
import Breadcrumbs_Holder from "../../Common_Component/Breadcrumbs_Holder/Breadcrumbs_Holder";
import Multimedia_Services_Benefits from "./Multimedia_Services_Benefits/Multimedia_Services_Benefits";
import Who_Should_Use_This from "./Who_Should_Use_This/Who_Should_Use_This";
import Multimedia_Why_Choose_Us from "./Multimedia_Why_Choose_Us/Multimedia_Why_Choose_Us";
import { useParams } from "react-router-dom";
import Banner from "../Digital_Media_Services_Inner/Banner/Banner";

function Multimedia_Services_inner() {
  const [data, setData] = useState();
  const [data1, setData2] = useState();
  const [imgSrc, setImgSrc] = useState("");
  const { id } = useParams();
  const breadcrumbs = [
    { label: "Multimedia Services", link: "/services-inner/2", active: false },
    {
      label: data?.Heading_1 || "Digital Screens", // Dynamically update label based on data
      link: "",
      active: true,
    },
  ];

  useEffect(() => {
    const filteredArray = Services_info_data.find(
      (item) => item.id === Number(id)
    );
    setData(filteredArray || {});

    const filteredArray2 = Why_Choose_us_data.find(
      (item) => item.id === Number(id)
    );
    setData2(filteredArray2 || {});

    const bannerImages = {
      1: "/Assets/Images/Banners/Digital_Screens_banner/Digital_Screens_banner.png",
      2: "/Assets/Images/Banners/Redio_banner/Redio_banner.png",
      3: "/Assets/Images/Banners/TVS_Banner/TVS_Banner.png",
      4: "/Assets/Images/Banners/Theator_banner/Theator_banner.png",
      5: "/Assets/Images/Banners/Airport_Banner/Airport_Banner.png",
    };
    setImgSrc(
      bannerImages[id] ||
        "/Assets/Images/Banners/Digital_Screens_banner/Digital_Screens_banner.png"
    );
  }, [id]);



  const Services_info_data = [
    {
      id: 1,
      Heading_1: "Digital Screens",
      desc_1:
        "LED display advertising is a vibrant and versatile way to showcase your brand. Ideal for both indoor and outdoor locations, these high-resolution displays ensure your message stands out, day or night. ",

      Heading_2: "How It Works",
      desc_2:
        "LED screens display eye-catching visuals, videos, or text-based messages in high-traffic areas. Their brightness and clarity make them perfect for capturing attention even in challenging lighting conditions.",

      imgSrc:
        "/Assets/Images/Service/Services_inner/Multimedia_Services/Degital_screens/digital_screen.png",
      getInTouch_Title: "Make your brand ",
      getInTouch_Titl2: "impossible to ignore!",
      getInTouch_Descn:
        "Get in touch to start your LED display advertising campaign today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/digital_screen.png",
      vidowala: false,
    },
    {
      id: 2,
      Heading_1: "Radio",
      desc_1:
        "Radio advertising continues to be one of the most reliable ways to connect with audiences. By airing ads, jingles, & sponsorships during popular shows, brands can reach listeners during their commutes, leisure time, or work hours. With the rise of regional radio stations, you can even target specific languages, cultures, or geographic areas.",

      Heading_2: "How It Works",
      desc_2:
        "We collaborate with leading FM and AM stations to air your ads during high- listenership times. From crafting catchy jingles to scripting impactful messages, we handle it all to ensure your brand resonates with the audience.",

      imgSrc:
        "/Assets/Images/Service/Services_inner/Multimedia_Services/Redio/Redio.png",
      getInTouch_Title: "Want to broadcast your ",
      getInTouch_Titl2: "brand to the masses? ",
      getInTouch_Descn:
        "Let’s amplify your presence on radio waves - Call us Today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/radio.png",
      vidowala: false,
    },
    {
      id: 3,
      Heading_1: "TV Ads",
      desc_1:
        "Television advertising is one of the most powerful tools for building brand awareness and credibility. Combining visuals, sound, and storytelling, TV ads leave a lasting impact on audiences. Whether it’s a 10-second jingle or a cinematic 60-second spot, television connects with viewers in a way no other medium can.",

      Heading_2: "How It Works",
      desc_2:
        "Your TV ad will be broadcast on specific channels & time slots that align with your target audience. We help you strategize everything—from ad concept and production to placement and analytics.",

      imgSrc:
        "/Assets/Images/Service/Services_inner/Multimedia_Services/TVS/tvs.png",
      getInTouch_Title: "Ready to make  ",
      getInTouch_Titl2: "your brand a household name? ",
      getInTouch_Descn: "Book your TV ad campaign with us now!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/tv.png",
      vidowala: false,
    },

    {
      id: 4,
      Heading_1: "Theatres Ads",
      desc_1:
        "Theatre advertising delivers your message to a captive audience in a premium entertainment setting. With ads displayed on the big screen or within theatre lobbies, your brand gets unparalleled exposure among engaged viewers.",

      Heading_2: "How It Works",
      desc_2:
        "We create high-quality visuals or videos tailored to the movie-watching experience. Your ad will be shown before or during screenings, along with lobby displays like posters and standees for added visibility.",

      imgSrc:
        "/Assets/Images/Service/Services_inner/Multimedia_Services/Theator/Theoter.png",
      getInTouch_Title: "Let your brand ",
      getInTouch_Titl2: "steal the spotlight on the big screen.",
      getInTouch_Descn: "Contact us today to launch your theatre ad campaign!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/theater.png",
      vidowala: false,
    },

    {
      id: 5,
      Heading_1: "Airport TV Ads",
      desc_1:
        "Airport TV advertising is a premium way to reach a captive and affluent audience. Strategically placed in lounges, terminals, and high-traffic zones, these ads leverage the extended dwell times of travellers to create memorable brand experiences.",

      Heading_2: "How It Works",
      desc_2:
        "Airport TVs display high-definition videos, animations, or slide-based ads tailored to target a diverse audience. With controlled placements and repeat visibility, brands can ensure their message resonates with travellers.",

      imgSrc:
        "/Assets/Images/Service/Services_inner/Multimedia_Services/Airport/Airport.png",
      getInTouch_Title: "Want to take your  ",
      getInTouch_Titl2: "brand global? ",
      getInTouch_Descn:
        " Partner with us for impactful Airport TV advertising today!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/airport.png",
      vidowala: false,
    },
  ];

  const benefitsData = [
    {
      title: "Attention-Grabbing",
      descn: "Bright, vivid displays ensure your ad gets noticed.",
    },
    {
      title: "Durability",
      descn:
        "Designed to withstand outdoor conditions while maintaining high performance.",
    },
    {
      title: "Versatility",
      descn: "Bright, vivid displays ensure your ad gets noticed.",
    },
    {
      title: "Cost-Effective",
      descn:
        "Reusable screens minimize ongoing costs compared to traditional billboards.",
    },
    {
      title: "Flexible Scheduling",
      descn:
        "Update ads based on time of day, audience demographics, or events.",
    },

    {
      title: "Attention-Grabbing",
      descn: "Bright, vivid displays ensure your ad gets noticed.",
    },
    {
      title: "Durability",
      descn:
        "Designed to withstand outdoor conditions while maintaining high performance.",
    },
    {
      title: "Versatility",
      descn: "Bright, vivid displays ensure your ad gets noticed.",
    },
    {
      title: "Cost-Effective",
      descn:
        "Reusable screens minimize ongoing costs compared to traditional billboards.",
    },
    {
      title: "Flexible Scheduling",
      descn:
        "Update ads based on time of day, audience demographics, or events.",
    },
  ];

  const Why_Choose_us_data = [
    {
      id: 1,
      text1:
        " We specialize in delivering tailored LED display campaigns. From content creation to placement in high-visibility zones, we handle every aspect to ensure your brand shines brightly.",
      text2:
        " Make your brand impossible to ignore! Get in touch to start your LED display advertising campaign today!",
    },

    {
      id: 2,
      text1:
        " We partner with top radio networks, offer flexible ad slots, and create compelling scripts to ensure your brand gets noticed.",
      text2:
        " Want to broadcast your brand to the masses? Let’s amplify your presence on radio waves—call us today!",
    },


    {
      id: 3,
      text1:
        " From ideation to execution, we handle everything, including scripting, filming, editing, and placement on the most relevant channels.",
      text2:
        " Ready to make your brand a household name? Book your TV ad campaign with us now!",
    },


    {
      id: 4,
      text1:
        "Our experts help you design and place theatre ads that captivate and convert audiences effectively.",
      text2:
        "Let your brand steal the spotlight on the big screen. Contact us today to launch your theatre ad campaign!",
    },

    {
      id: 5,
      text1:
        "Reachout Media Tech Pvt. Ltd. offers a seamless end-to-end solution, from crafting compelling ad creatives to securing premium screen placements in busy airport zones. Our campaigns are designed to ensure maximum recall and ROI.",
      text2:
        "Want to take your brand global? Partner with us for impactful Airport TV advertising today!",
    },
  ];
  return (
    <>
      <section className="Multimedia_Services_inner">
        <Banner imgSrc={imgSrc} />

        <Breadcrumbs_Holder breadcrumbs={breadcrumbs} data={data} />

        <Multimedia_Services_info
          Heading_1={data?.Heading_1}
          desc_1={data?.desc_1}
          Heading_2={data?.Heading_2}
          desc_2={data?.desc_2}
          imgSrc={data?.imgSrc}
        />

        <Multimedia_Services_Benefits benefitsData={benefitsData} />

        <Who_Should_Use_This />

        <Multimedia_Why_Choose_Us text1={data1?.text1} text2={data1?.text2} />

        <Get_In_Touch
          vidowala={data?.vidowala != undefined ? data?.vidowala : true}
          getInTouch_Img={data?.getInTouch_Img}
          getInTouch_Title={data?.getInTouch_Title}
          getInTouch_Titl2={data?.getInTouch_Titl2}
          getInTouch_Descn={data?.getInTouch_Descn}
        />
      </section>
    </>
  );
}

export default Multimedia_Services_inner;
